import o from "./chunk830.js";
import r from "./chunk822.js";
import t from "./chunk835.js";
import e from "./chunk836.js";
const a = e({
  themeId: r,
  defaultTheme: o,
  rootShouldForwardProp: t
});
export {
  a as default,
  t as rootShouldForwardProp
};
